import { render } from "./MultimediaView.vue?vue&type=template&id=7b168866&lang=true"
import script from "./MultimediaView.vue?vue&type=script&lang=js"
export * from "./MultimediaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__